module.exports = __webpack_public_path__ + "img/levno.d9bbb0fe.svg";